<template>
  <div class="fireBook">
    <div class="download-warp" :class="{ floating: !showClose }" :style="showClose ? 'margin-top: 10px' : ''">
      <el-button type="success" size="small" icon="el-icon-download" plain @click="handleDownload">下载记录单</el-button>
      <el-button v-if="showClose" style="margin-right: 10px;" size="danger" icon="el-icon-close" plain @click="handleClose">关闭</el-button>
    </div>
    <div class="smoke-content "
         :class="{
          'auto': autoHeight,
         }"
         v-loading="!dataLoaded"
         element-loading-text="加载中..."
    >
      <el-row v-if="dataLoaded">
        <el-col :span="6" v-if="!isCompleted">
          <h1 class="smoke-h1">任务详情</h1>
          <div class="smoke-item smoke-task">
            <el-form label-width="120px">
              <el-form-item v-if="taskTp" label="任务类型："><span>{{ taskTp }}</span></el-form-item>
              <el-form-item label="地址："><span>{{ selectRow.alarmSingle.disasterAddress }}</span></el-form-item>
              <el-form-item label="设备编码：" v-if="selectRow.alarmSingle.singleState === '37'"><span>{{ selectRow.alarmSingle.deviceid }}</span></el-form-item>
              <el-form-item label="出动单位："><span>{{ selectRow.deptDO.name }}</span></el-form-item>
              <el-form-item label="出动人："><span>{{ selectRow.alarmSingle.responsiblePerson ? selectRow.alarmSingle.responsiblePerson.replace(/,(?=$)/, '') : '-'}}</span></el-form-item>
              <el-form-item label="发现时间："><span>{{ selectRow.alarmSingle.alarmTime || '-' }}</span></el-form-item>
              <el-form-item label="派单时间："><span>{{ selectRow.alarmSingle.reportTime || '-' }}</span></el-form-item>
              <el-form-item label="到场时间：" v-if="showTime"><span>{{ selectRow.alarmSingle.arrivalTime || '-' }}</span>
              </el-form-item>
              <el-form-item label="收队时间："><span>{{ selectRow.alarmSingle.backTime || '-' }}</span>
              </el-form-item>
              <template
                v-if="selectRow.alarmSingle.singleState && (selectRow.alarmSingle.singleState == 0 || selectRow.alarmSingle.singleState == 3 || selectRow.alarmSingle.singleState == 4) ">
                <el-form-item label="报警人姓名："><span>{{ selectRow.alarmSingle.masterName }}</span></el-form-item>
                <el-form-item label="报警人电话："><span>{{ selectRow.alarmSingle.contactTelephone }}</span>
                </el-form-item>
                <el-form-item label="报警描述："><span>{{ selectRow.alarmSingle.remarks }}</span></el-form-item>
              </template>
            </el-form>
          </div>
        </el-col>
        <el-col :span="isCompleted ? 24 : (showMember ? 12 : 18)">
          <h1 class="smoke-h1">处置记录</h1>
          <div class="fire-completed-info" v-if="isCompleted">
            <div class="completed-field">
              <span class="completed-label">地址：</span>
              <span class="completed-value">{{ selectRow.alarmSingle.disasterAddress }}</span>
            </div>
            <div class="completed-field">
              <span class="completed-label">责任人：</span>
              <span class="completed-value">{{ selectRow.alarmSingle.responsiblePerson ? selectRow.alarmSingle.responsiblePerson.replace(/,(?=$)/, '') : '-' }}</span>
            </div>
          </div>
          <div class="smoke-item smoke-fire">
            <el-steps
              direction="vertical"
              finish-status="error"
              :active="200"
              space="0"
            >
              <el-step
                  v-for="(item, index) in timelines"
                  :key="index"
                  :timestamp="item.createAt"
              >
                <div slot="description">
                  <div class="fire-time">
                    <span>{{ item.createTime }}</span>
                    <span>{{ item.userName }}</span>
                  </div>

                  <div v-if="item.msg" :class="item.reportType == 4 ? 'fire-title font-weight' : 'fire-title'">
                    <span v-html="item.msg.replace(/\\n/g, '<br>')"></span>
                    <el-icon v-if="item.coordinate" name="location"/>
                  </div>

                  <div class="fire-media" v-if="item.coordinate || (item.reportType == 5 && item.longitude)">
                  </div>

                  <div class="fire-title" v-if="item.imgList && item.imgList.length > 0">
                    <span v-for="(imgItem, ydex) in item.imgList" :key="ydex">
                      <el-image
                          :src="imgItem"
                          style="height: 60px"
                          fit="contain"
                          :preview-src-list="item.imgList"
                      />
                    </span>
                  </div>

                  <div class="fire-title" v-if="item.reportType == 2 && item.video">
                    <video
                        :src="item.video"
                        controls="controls"
                        type="video/mp4"
                        width="260px"
                        height="140px"
                    ></video>
                  </div>

                  <span v-if="item.reportType == 5" class="fire-desc">{{ item.location }}</span>
                </div>
              </el-step>
            </el-steps>
            <div class="fire-form-container" v-if="!isCompleted">
              <div class="fire-input-group">
                <el-input
                    v-model="dispatchText"
                    type="textarea"
                    :rows="3"
                    resize="none"
                    placeholder="请输入指挥调度内容..."
                    class="custom-textarea"
                ></el-input>
                <el-button
                    type="primary"
                    class="send-btn-tall"
                    :loading="sending"
                    @click="handleSend"
                >
                  发 送
                </el-button>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6" v-if="showMember && !isCompleted">
          <h1 class="smoke-h1">{{ selectRow.alarmSingle.singleState === '21' ? '处置成员' : '调派力量' }}</h1>
          <div class="smoke-item smoke-combat">
            <div class="smoke-con">
              <h4 v-show="firefighter_num">成员获取失败...</h4>
              <table
                  v-show="taskUserList.length !== 0 "
                  border="0"
                  v-for="(item, index) in taskUserList"
                  :key="index"
              >
                <tr>
                  <td>
                    <span style="text-align: left; width: 100px">{{
                        item.name
                      }}</span>
                  </td>
                  <td style="text-align: left">
                    <span>{{ formatMsg(item.msg) }}</span>
                  </td>
                  <td style="text-align: right">
                    <span>
                      {{ item.phone }}
                    </span>
                    <img
                        src="~@/assets/img/phone.png"
                        @click="ringUp(item)"
                        style="width: 20px; vertical-align: middle; cursor: pointer;"
                    />
                  </td>
                </tr>
              </table>
              <!--              <div class="smoke-map">-->
              <!--                <el-button-->
              <!--                    type="primary"-->
              <!--                    round-->
              <!--                    @click="addPolice"-->
              <!--                    v-if="dataFinish"-->
              <!--                    disabled-->
              <!--                >增派队员</el-button-->
              <!--                >-->
              <!--                <el-button-->
              <!--                    type="primary"-->
              <!--                    round-->
              <!--                    @click="addPolice"-->
              <!--                    v-else-->
              <!--                >增派队员</el-button-->
              <!--                >-->
              <!--                &lt;!&ndash; <el-button-->
              <!--                  type="primary"-->
              <!--                  style="width: 30%"-->
              <!--                  round-->
              <!--                  @click="support"-->
              <!--                  >联防支援</el-button-->
              <!--                > &ndash;&gt;-->
              <!--                <el-button-->
              <!--                    type="primary"-->
              <!--                    style="width: 30%"-->
              <!--                    round-->
              <!--                    @click="openVideo"-->
              <!--                    v-if="show"-->
              <!--                >查看视频</el-button-->
              <!--                >-->
              <!--                <el-button-->
              <!--                    type="primary"-->
              <!--                    style="width: 30%"-->
              <!--                    round-->
              <!--                    @click="openVideo1"-->
              <!--                    v-if="show1"-->
              <!--                >查看视频</el-button-->
              <!--                >-->
              <!--              </div>-->
            </div>
            <div id="Player" v-if="show2"></div>
          </div>
        </el-col>
      </el-row>
      <div v-else class="loading-placeholder"></div>
    </div>
    <el-dialog title="呼叫确认" class="fireDoc fireDocCall" :class="{ ['red-theme-dialog']: isRedStyleTp }" :visible.sync="dialogVisible" width="300px" append-to-body center :modal-append-to-body="true">
      <div class="call-info">
        <p><span class="label">姓名：</span><span class="value">{{ removeNbsp(callPolie.name) }}</span></p>
        <p><span class="label">部门：</span><span class="value">{{ removeNbsp(callPolie.msg) }}</span></p>
        <p><span class="label" v-if="callPolie.phone">电话：</span><span class="value">{{ callPolie.phone }}</span></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="toCall()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import JSZipUtils from "jszip-utils";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import ImageModule from "docxtemplater-image-module-free";
import axios from "axios";
import VueOfficeDocx from "@vue-office/docx";
import '@vue-office/docx/lib/index.css'
import {checkImageOrientation, ImageOrientation} from "@/js/common";
import {saveAs} from 'file-saver';
import {redStyleTp} from "@/js/constants";

export default {
  name: "fireBook",
  components: {VueOfficeDocx},
  props: {
    showTime: {
      type: Boolean,
      default: true
    },
    showMember: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: false
    },
    alarmId:{
      type: String,
      default: ''
    },
    // 防火巡查
    isFire:{
      type: Boolean,
      default: false
    },
    taskReportUrl: {
      type: String,
      default: '/writ/taskReport'
    },
    // 社区
    community:{
      type: String,
      default: ''
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialogVisible: false,
      callPolie: {
        name: '',
        msg: '',
        phone: ''
      },
      dispatchText: '',
      sending: false,
      fileTitle: '',
      file: '',
      firefighter_num: false,
      taskUserList: [],
      dataLoaded: false,
      fileLoading: false,
			alarmId1:'',
      selectRow: {
        alarmSingle:{
          number:'',
          closingacaseTime:'',
          singleState:0,
          masterName:'',
          contactTelephone:'',
          remarks:'',
          alarmTime:'',
          disasterAddress:'',
          reportTime:'',
          disposeState:'',
          arrivalTime:'',
          backTime: '',
          closingTime:'',
          participateNumber:'',
          equipmentNumber:'',
        },
        deptDO:{
          name:'',
        }
      },
      pageAddress: "灾害地质:",
      timelines: [],
      taskTp: '',
      electricalOptions: {
        4: "过压",
        5: "欠压",
        6: "过载",
        7: "入户充电",
        8: "零用电",
        2: "火线温度",
        3: "零线温度",
        1: "漏电"
      },
      // 防火巡查状态
      inspectOptions: {
        "2": "疏散通道",
        "4": "消防通道",
        "5": "电动自行车",
        "8": "防火门",
        "11": "消火栓",
        "12": "灭火器"
      },
      ryInspectOptions: {
        '1': '满冒',
        '2': '遗撒',
        '3': '脏污',
        '4': '未开盖',
        '5': '人员值守',
        '6': '规范设置',
        '7': '外摆桶',
        '8': '容器破损',
        '10': '大件垃圾',
        '14': '再生回收',
        '15': '宣传氛围',
        "16": "考核加分",
        "9": "落地垃圾",
      }
    };
  },
  created() {
    this.alarmId1 = this.alarmId;
    this.dataLoaded = false;
    this.timelines = [];  // 火场内容
    this.fileTitle = ''
    this.file = ''
    this.selectRow = {
      alarmSingle: {
        number: '',
        closingacaseTime: '',
        singleState: 0,
        masterName: '',
        contactTelephone: '',
        remarks: '',
        alarmTime: '',
        disasterAddress: '',
        reportTime: '',
        disposeState: '',
        arrivalTime: '',
        backTime: '',
        closingTime: '',
        participateNumber: '',
        equipmentNumber: '',
      },
      deptDO: {
        name: '',
      },
    };
    this.fetchData();
  },
  computed: {
    isRedStyleTp() {
      return this.$store.state.styleTp === redStyleTp
    },
    isCompleted() {
      return !!(this.selectRow.alarmSingle && this.selectRow.alarmSingle.backTime);
    },
  },
  methods: {
    removeNbsp(str) {
      if (!str) return '';
      return str.replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
    },
    formatMsg(msg) {
      if (msg === null || msg === undefined) return '';
      return String(msg).replace(/,+$/, '');
    },
    ringUp(member) {
      this.callPolie = {
        name: member.name,
        msg: this.formatMsg(member.msg),
        phone: member.phone
      };
      this.dialogVisible = true;
    },
    toCall() {
      // 呼叫逻辑
      this.$message.success("呼叫成功");
      // const phone = this.callPolie.phone;
      // let _this = this;
      // var success = function (resp) {
      //   if (resp.code === "0") {
      //     _this.$message.success("呼叫成功");
      //     _this.dialogVisible = false;
      //   } else {
      //     _this.$message.warning("呼叫失败");
      //   }
      // };
      // _this.http.post("/webapi/writ/voiceCalls", { phone: phone }, success);
    },
    queryTaskUserList() {
      this.http.get(
          "/webapi/writ/taskUserList",
          {taskId: this.alarmId},
          (resp) => {
            if (resp.code === '0') {
              this.taskUserList = Array.isArray(resp.data) ? resp.data : [];
              this.firefighter_num = false;
            } else {
              this.firefighter_num = true;
            }
          }
      );
    },
    handleSend() {
      if (!this.dispatchText.trim()) {
        return this.$message.warning('请输入调度内容');
      }

      this.sending = true;
      const params = {
        reportMsg: this.dispatchText,
        taskId: this.alarmId
      };

      // 对接接口
      this.http.postData("/wx/miniProgram/addReport", params, (resp) => {
        this.sending = false;
        if (resp.code === '0') {
          this.$message.success('发送成功');
          this.dispatchText = '';
          this.fetchData();
        } else {
          this.$message.error(resp.msg || '发送失败');
        }
      }, (err) => {
        this.sending = false;
        this.$message.error('发送失败，请重试');
      });
    },
    handleClose() {
      window.close()
    },
    handleDownload() {
      saveAs(this.file, `${this.fileTitle}.docx`);
    },
    fetchData() {
      this.fileLoading = true;
      const stateMapping = {
        8: {pageAddress: "设备位置", pinkName: "火眼报警"},
        7: {pageAddress: "设备位置", pinkName: "消防车道占用报警"},
        9: {pageAddress: "设备位置", pinkName: "楼道堆物堆料报警"},
        5: {pageAddress: "设备位置", pinkName: "手报报警调度派单"},
        4: { pinkName: "隐患报警调度派单" },
        0: { pinkName: "119调度派单" },
        3: { pinkName: "微信调度派单" },
        6: {pageAddress: "设备位置", pinkName: "电动车报警调度派单"},
        1: { pinkName: "拉动演练调度派单" },
        11: { pinkName: "防火巡查" },
        10: { pinkName: "防火门" },
        2: { pinkName: "烟感调度派单" },
        13: { pinkName: "后厨报警派单" },
        19: { pinkName: "呼叫报警" },
        17: { pinkName: "紫外报警" }
      };

      this.showMember && this.queryTaskUserList()

      let completedRequests = 0;
      const totalRequests = 2;
      let respOneData = null;
      let respTwoData = null;

      const handleResponse = () => {
        if (completedRequests === totalRequests) {
          this.dataLoaded = true;
          this.selectRow = respOneData || {};
          if (!this.selectRow.alarmSingle) this.selectRow.alarmSingle = {};
          if (!this.selectRow.deptDO) this.selectRow.deptDO = {name: ''};
          this.taskTp = '';
          this.pageAddress = '';
          this.pinkName = '';

          const state = respOneData.alarmSingle.singleState;
          if (stateMapping.hasOwnProperty(state)) {
            const config = stateMapping[state];
            this.pageAddress = config.pageAddress || this.pageAddress;
            this.pinkName = config.pinkName || this.pinkName;
          }
          // 处理 electricalType 的特殊情况
          if (state === "26" && respOneData.alarmSingle.electricalType) {
            this.pinkName = `${this.electricalOptions[respOneData.alarmSingle.electricalType]}报警`;
          }
          this.taskTp = this.pinkName;
          const respTwo = respTwoData && respTwoData.data ? respTwoData.data : {};
          if (this.taskReportUrl === '/writ/taskReport') {
            this.timelines = respTwo || [];
          } else {
            this.timelines = respTwo.value || [];
            this.taskTp = respTwo.types
          }

          if (state === "21" || state === "35") {
            this.timelines = this.timelines.map(it => {
              if (it.userName === '智慧消防系统') {
                it.userName = '智能调度系统'
              }
              return it
            })
          }

          // 防火巡查处理
          if (state === '11' && respOneData.alarmSingle.combustion) {
            this.taskTp = this.inspectOptions[respOneData.alarmSingle.combustion] || '防火巡查'
          }

          const date = dayjs(this.selectRow.alarmSingle.alarmTime)
          this.fileTitle = `${this.selectRow.alarmSingle.alarmTime}-${this.taskTp}`

          const timelines = this.timelines.map(it => {
            return {
              time: it.createTime,
              user: it.userName,
              msg: it.msg,
            }
          }).filter(it => it.msg && it.reportType !== 2)

          // 格式化图片
          const images = this.timelines.reduce((acc, it) => {
            if (it.imgList && it.imgList.length > 0) {
              // 过滤mp4格式
              it.imgList = it.imgList.filter(it => !it.includes('.mp4'))
              acc.push(...it.imgList)
            }
            return acc
          }, []).reverse()

          // 0.处置中 1.已处置  3.未处置
          const allClosingacaseState = {
            0: '处置中',
            1: '已处置',
            3: '未处置'
          }

          const statusText = allClosingacaseState[this.selectRow.alarmSingle.closingacaseState] || '未处理'
          let way = this.isFire ? '人员防火巡查' : '智能监测设备'
          let title = '处置记录'

          if (state === '35') {
            title = '处置记录'
            way = '人员巡查'
            this.taskTp = this.ryInspectOptions[respOneData.alarmSingle.combustion] || '人员巡查'
          } else if (state === '21') {
            title = '处置记录'
            this.taskTp = this.ryInspectOptions[respOneData.alarmSingle.combustion] || '垃圾分类'
          }

          const data = {
            title,
            // 巡查日期
            yyyy: date.format("YYYY"),
            mm: date.format("MM"),
            dd: date.format("DD"),
            // 问题发现方式
            way,
            // 地址
            address: this.selectRow.alarmSingle.disasterAddress,
            // 巡查人 \ 巡查人
            responsiblePerson: this.selectRow.alarmSingle.responsiblePerson ? this.selectRow.alarmSingle.responsiblePerson.replace(/,(?=$)/, '') : '',
            // 责任单位
            responsibleUnit: this.community || this.selectRow.deptDO.name,
            // 任务类型
            taskTp: this.taskTp,
            timelines: timelines.reverse(),
            statusText
          }
          this.generateDocument(data, images)
        }
      };

      this.http.get("/webapi/probe/qureyvide/" + this.alarmId, {}, (resp) => {
        respOneData = resp;
        completedRequests++;
        handleResponse();
      });

      this.http.get(`/webapi${this.taskReportUrl}/` + this.alarmId1, {}, (resp) => {
        respTwoData = resp;
        completedRequests++;
        handleResponse();
      });
    },
    async convertImageUrlToBase64(url, w, h) {
      try {
        const response = await axios.get(url, {responseType: 'arraybuffer'})
        const blob = new Blob([response.data], {type: response.headers['content-type']})
        const imageUrl = URL.createObjectURL(blob)

        const image = new Image()
        image.src = imageUrl

        return new Promise((resolve, reject) => {
          image.onload = () => {
            const targetWidth = w * 2
            const targetHeight = h * 2

            const canvas = document.createElement('canvas')
            canvas.width = targetWidth
            canvas.height = targetHeight
            const ctx = canvas.getContext('2d')

            // 先填充白色背景（可以修改为任意颜色）
            ctx.fillStyle = '#FFFFFF' // 使用白色背景，可修改颜色值如 '#0000FF'
            ctx.fillRect(0, 0, canvas.width, canvas.height) // 这行必须放在绘制图像之前

            // 计算缩放比例并确定绘制位置
            const scale = Math.min(targetWidth / image.width, targetHeight / image.height)
            const x = (targetWidth / 2) - (image.width * scale / 2)
            const y = (targetHeight / 2) - (image.height * scale / 2)

            // 绘制图像到 Canvas
            ctx.drawImage(image, x, y, image.width * scale, image.height * scale)

            // 获取 Base64 格式的数据
            const base64Image = canvas.toDataURL(response.headers['content-type'])

            // 清理
            URL.revokeObjectURL(imageUrl)

            resolve(base64Image)
          }

          image.onerror = (error) => {
            reject(new Error('图像加载失败'))
          }
        })
      } catch (error) {
        console.error('转换出错:', error)
        return null;
      }
    },
    async getImages(images, key) {
      const result = images.map(it => {
        return {
          src: it
        }
      })

      console.log(images, 'images')
      await Promise.all(result.map(async (it, index) => {
        const w = key === 'l' ? 860 : 540
        const h = key === 'l' ? 487 : 720
        it[key] = await this.convertImageUrlToBase64(it.src, w, h);
      }));
      console.log(result, 'result')
      return result
    },
    async formatData(data, images) {
      return new Promise(async (resolve, reject) => {
        let firstImage = []
        let lastImage = []
        if (images && images.length > 0) {
          const firstUrl = images[0]
          const orientation = await checkImageOrientation(firstUrl)
          // 判断第一张是否是横图
          if (orientation === ImageOrientation.LANDSCAPE) {
            firstImage = [images[0]]
            lastImage = images.slice(1)
          } else {
            firstImage = []
            lastImage = images
          }
        }
        let firstImagesRes = []
        if (firstImage && firstImage.length > 0) {
          firstImagesRes = await this.getImages(firstImage, 'l')
        }
        const imagesRes = await this.getImages(lastImage, 'l')
        // 整改文字
        resolve({
          ...data,
          firstImages: firstImagesRes,
          images: imagesRes,
        })
      })
    },
    generateDocument(data, images) {
      const base64Regex = /^(?:data:)?image\/(png|jpg|jpeg|svg|svg\+xml);base64,/;
      const validBase64 = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
      const templatePath = require(`@/assets/template/jld.docx`)

      function base64Parser(dataURL) {
        if (
          typeof dataURL !== "string" ||
          !base64Regex.test(dataURL)
        ) {
          return false;
        }

        const stringBase64 = dataURL.replace(base64Regex, "");

        if (!validBase64.test(stringBase64)) {
          throw new Error(
            "Error parsing base64 data, your data contains invalid characters"
          );
        }

        // For nodejs, return a Buffer
        if (typeof Buffer !== "undefined" && Buffer.from) {
          return Buffer.from(stringBase64, "base64");
        }

        // For browsers, return a string (of binary content) :
        const binaryString = window.atob(stringBase64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          const ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        return bytes.buffer;
      }

      const imageOptions = {
        getImage(tag) {
          return base64Parser(tag);
        },
        getSize(_, _src, typeKey) {
          if (typeKey === 'p') {
            return [270, 360]
          }
          if (typeKey === 'l') {
            return [430, 241]
          }
          return [270, 360]
        },
      }
      JSZipUtils.getBinaryContent(templatePath, (error, content) => {
        if (error) {
          throw error
        }
        const zip = new PizZip(content)
        const doc = new Docxtemplater(zip, {
          paragraphLoop: true,
          linebreaks: true,
          modules: [new ImageModule(imageOptions)]
        })

        this.formatData(data, images)
          .then(data => {
            doc.setData(data);
            try {
              doc.render();
              this.file = doc.getZip().generate({
                type: 'blob',
                mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
              })
              this.fileLoading = false
            } catch (error) {
              this.fileLoading = false
              this.file = ''
              this.$message.error('生成文档出错', error)
            }
          })
          .catch(err => {
            this.$message.error(err)
          })
      });
    },
  },
};
</script>

<style lang="less">
.fireBook {
  position: relative;
  .el-table tr td:nth-child(1) {
    color: #fff !important;
  }

  .el-table tr th {
    display: none;
  }

  .el-table tr td,
  .el-table tr th {
    color: #b4b4b4 !important;
    border-bottom: 0px;
    background: #3b3b3b !important;
  }

  .el-tabs__nav-wrap {
    border-radius: 16px;
    -webkit-box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.7);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.7);
  }

  .el-dialog__title {
    color: #fff;
    line-height: 30px;
    text-shadow: 1px 2px 10px rgba(4, 0, 0, 0.7);
  }

  .fireBookBox {
    .el-tabs__header {
      margin: 0px;
      border: 1px solid #fff;
    }

    .police,
    .taskDetail,
    .policeOutNum {
      border: 1px solid rgb(0, 0, 0);
    }

    border-radius: 16px;

    .el-tabs__active-bar {
      height: 7px;
      background: #ebeb6c;
      border-radius: 4px;
    }

    .el-tabs__nav {
      line-height: 64px;
      height: 64px;
      padding-top: 15px;
    }

    .taskDetail {
      color: rgb(0, 0, 0);

      .el-form-item__label {
        color: rgb(0, 0, 0);
      }
    }

    .fireDoc {
      .el-dialog {
        border-radius: 18px;
      }
    }
  }

  .smoke-content {
    padding: 0;
    overflow: auto;
    //height: 79vh;

    &.auto {
      height: calc(100% - 16px);
    }

    h1.smoke-h1 {
      font-size: 16px;
      padding: 0px 0 10px;
      color: #333333;
      line-height: 25px;
      font-weight: normal;
      text-align: center;
    }

    .smoke-item {
      height: 680px;
      padding: 16px 0 8px;
      background: rgba(200, 232, 255, 0.3);
      border-radius: 8px;
      overflow-y: auto;
    }

    .smoke-task {
      .el-step__head.is-error {
        color: #ffffff !important;
        border-color: #f56c6c;
      }

      .el-form-item {
        margin-bottom: 0px;
        border-bottom: 1px dashed #eaeaea;

        .el-form-item__label {
          font-size: 12px;
        }

        .el-form-item__content {
          padding: 0 20px 0 0;

          span {
            font-size: 12px;
          }
        }
      }
    }

    .smoke-fire {
      margin: 0 16px;
      display: flex;
      flex-direction: column;
      height: 680px;
      padding: 16px 0 0 !important;
      background: rgba(200, 232, 255, 0.3);
      border-radius: 8px;
      overflow: hidden;

      .el-steps {
        flex: 1;
        padding: 0 20px 10px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 3px;
        }

        .el-step__head.is-error {
          color: #fcf8f8 !important;
          border-color: #0080db !important;
        }
        .el-step.is-vertical {
          display: -webkit-box;
        }

        .el-step.is-vertical .el-step__line {
          width: 1px;
          left: 4px;
        }

        .el-step__icon {
          width: 10px;
          height: 10px;

          .el-step__icon-inner {
            display: none;
          }
        }
      }

      .fire-time {
        font-size: 12px;
        font-weight: 400;
        color: #999999;

        span {
          padding: 0px 10px;
        }
      }

      .fire-title {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        padding: 2px 10px 0;

        video{
          background:rgba(19, 18, 18, 0.842);
        }
      }

      .font-weight {
        font-weight: bold;
      }

      .fire-desc {
        padding: 2px 10px 0;
        color: #0a0a0a
      }

      .fire-media {
        padding: 2px 10px 0;
      }
    }

    .smoke-combat {
      padding: 20px 20px 0;

      .smoke-con {
        overflow-y: auto;
      }

      table {
        width: 100%;

        td {
          text-align: center;
          padding: 8px 0;

          span {
            display:block;
            width:100%;
            text-align:left;
            font-size: 12px;
            color: #333333;
            width: 80%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        td:first-child {
          width: 23%;
          span{
            float:none
          }
        }
        td:nth-child(2) {
          width: 40%;
        }

        td:last-child {
          position:relative;
          width: 40%;
          span{
            width:calc(100% - 25px);
          }
          img{
            position:absolute;
            top:10px;
            right:0px
          }
        }

      }

      .smoke-map {
        padding: 10px 0px;

        .el-button {
          border-radius: 8px;
        }

        img {
          display: block;
          width: 100%;
          height: 150px;
        }
      }
    }
  }

  .loading-placeholder {
    min-height: 700px;
    background: rgba(200, 232, 255, 0.3);
    border-radius: 8px;
  }

  .fire-completed-info {
    padding: 16px 16px 8px;
    background: #ffffff;
    border-top: 1px solid #eeeeee;

    .completed-field {
      margin-bottom: 8px;
      font-size: 14px;

      .completed-label {
        color: #666666;
        font-weight: bold;
      }

      .completed-value {
        color: #333333;
      }
    }
  }

  .fire-form-container {
    padding: 12px 4px 2px;
    background: #ffffff;
    border-top: 1px solid #eeeeee;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);

    .fire-input-group {
      display: flex;
      align-items: stretch; /* 关键：子元素高度自动充满父级 */
      height: 100%;         /* 统一设置一组高度 */
      gap: 12px;

      .custom-textarea {
        flex: 1;
        // 深度作用选择器，修改 Element 原生样式
        /deep/ .el-textarea__inner {
          height: 100% !important;
          border-radius: 6px;
          padding: 8px 12px;
          &:focus {
            background: #fcfdfe;
          }
        }
      }

      .send-btn-tall {
        height: 100%;
        width: 80px;
        padding: 0;
        font-size: 15px;
        font-weight: bold;
        letter-spacing: 1px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
        }
      }
    }
  }
}

.j-police {
  margin: 10px auto 0px;
  width: auto;
  border-radius: 0px;
}

.smoke-content .el-dialog__header .el-icon-close{
  color:#fff;
}

.firePicture{
  position:relative;
  .el-upload-list{
    position:absolute;
    top:-5px;
    left:80px;
  }
}

.download-warp {
  display: flex;
  justify-content: flex-end;
}

.download-warp.floating {
  position: absolute;
  top: -5px;
  right: 0;
  z-index: 10;
}

.fireDocCall {
  .el-dialog__body{
    padding: 10px 0 10px 50px!important;
  }
}

.call-info {
  p {
    margin: 12px 0;
    font-size: 14px;
    .label {
      font-weight: bold;
      color: #333;
      display: inline-block;
      width: 60px;
    }
    .value {
      color: #666;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/fireBook/firePinkAlarm.vue